import React, {Component} from 'react';

export default class PersonHal extends Component {
  state = {
    value: ''
  };
  componentDidMount() {
    window.addEventListener('resize', this.resize.bind(this));
    this.resize();
  }

  // detecting screen size
  resize() {
    if (window.innerWidth <= 760) {
      this.setState({value: 'personS'});
    } else {
      this.setState({value: 'personH'});
    }
  }
  render() {
    const {img, name, job} = this.props.person;
    const {children} = this.props;

    const url = `https://randomuser.me/api/portraits/thumb/men/${img}.jpg`;
    return (
      <div className={this.state.value}>
        <img src={url} alt='' />
        <div>
          <h4>{name}</h4>
          <h4>{job}</h4>
          {children}
        </div>
      </div>
    );
  }
}
